export default __webpack_public_path__ + "static/media/me.649194f7.jpg";